import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import RenderIf from '../../../../../../renderIf';

import useStyles from './styles';

const FilterDropdown = (props) => {
    const { label, filterKey, filter, value, disabled, handleUpdate } = props;

    const classes = useStyles();

    return (
        <FormControl
            sx={{ m: 1, minWidth: 120 }}
            size="small"
        >
            <InputLabel
                id={`${label}-label`}
                sx={{ fontSize: '16px' }}
            >
                {label}
            </InputLabel>
            <Select
                label={label}
                labelId={`${label}-label`}
                id={`${label}-select`}
                value={value}
                onChange={(event) => {
                    handleUpdate(event.target.value, filterKey);
                }}
                className={classes.selectStyle}
                multiple
                IconComponent={(props) => (
                    <FontAwesomeIcon
                        {...props}
                        icon={faAngleDown}
                    />
                )}
                disabled={disabled}
            >
                {filter?.map?.((filterOpt) => {
                    return (
                        <MenuItem
                            key={`filter-choice-${filterOpt.id}`}
                            value={filterOpt.id}
                            label={`filter-choice-${filterOpt.id}`}
                            disabled={disabled}
                        >
                            {filterOpt.label}
                        </MenuItem>
                    );
                })}
            </Select>

            <RenderIf isTrue={value.length > 0}>
                <Button
                    onClick={() => handleUpdate([], filterKey)}
                    sx={{ color: (theme) => theme.palette.primary.main, fontSize: '10px', fontWeight: 600, maxWidth: 120 }}
                >
                    Clear filters
                </Button>
            </RenderIf>
        </FormControl>
    );
};

export default FilterDropdown;
